document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
        console.log("Times changing");
        changeTimes();

        // Create a MutationObserver to monitor changes in the DOM
        const observer = new MutationObserver(function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach(node => {
                        if (node.classList && (node.classList.contains('address-sec') || node.classList.contains('store-hours-detail'))) {
                            changeTimes();
                        }
                    });
                }
            }
        });

        // Start observing the document body for child node additions
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }, 50);
});

function changeTimes() {
    if (window.location.href.includes('find-a-store')) {
        console.log("STORE LOCATOR");
        const addressDivs = document.getElementsByClassName("address-sec");

        fetch(storeTimesUrl)
            .then(response => response.json())
            .then(data => {
                for (let i = 0; i < addressDivs.length; i++) {
                    const storeNameElement = addressDivs[i].getElementsByClassName('store-name')[0];

                    if (storeNameElement) {
                        const storeName = storeNameElement.textContent.trim();
                        let storeKeyFound = false;

                        for (const storeKey in data.stores) {
                            if (storeKey.includes(storeName)) {
                                storeKeyFound = true;
                                addressDivs[i].id = data.stores[storeKey].id;
                                console.log(`Matched store: ${storeName} with key: ${storeKey}`);

                                const addressDiv = addressDivs[i];
                                const daysTime = addressDiv.getElementsByClassName("days-time")[0];

                                if (!daysTime) {
                                    console.warn(`No "days-time" element found for store: ${storeName}`);
                                    continue;
                                }

                                addHolidayHours(data.stores[storeKey], daysTime);
                                break;
                            }
                        }

                        if (!storeKeyFound) {
                            console.warn(`Store not matched: ${storeName}. Using default settings.`);
                            const defaultStoreKey = "Default";
                            const defaultStore = data.stores[defaultStoreKey];
                            addressDivs[i].id = defaultStore.id;

                            const addressDiv = addressDivs[i];
                            const daysTime = addressDiv.getElementsByClassName("days-time")[0];

                            if (daysTime) {
                                addHolidayHours(defaultStore, daysTime);
                            }
                        }
                    }
                }
            })
            .catch(error => console.error('Error fetching store-times.json:', error));
    } else if (document.querySelector(".store-locator")) {
        console.log("Store Details");

        fetch(storeTimesUrl)
            .then(response => response.json())
            .then(data => {
                const storeNameElement = document.getElementsByClassName('store-name')[0];

                if (storeNameElement) {
                    const storeName = storeNameElement.textContent.trim();
                    let storeKeyFound = false;

                    for (const storeKey in data.stores) {
                        if (storeKey.includes(storeName)) {
                            storeKeyFound = true;

                            const daysTime = document.getElementsByClassName("days-time")[0];

                            if (daysTime) {
                                addHolidayHours(data.stores[storeKey], daysTime);
                            }

                            break;
                        }
                    }

                    if (!storeKeyFound) {
                        console.warn(`Store not matched in details view: ${storeName}. Using default settings.`);
                        const defaultStoreKey = "Default";
                        const defaultStore = data.stores[defaultStoreKey];

                        const daysTime = document.getElementsByClassName("days-time")[0];

                        if (daysTime) {
                            addHolidayHours(defaultStore, daysTime);
                        }
                    }
                }
            })
            .catch(error => console.error('Error fetching store-times.json:', error));
    }
}

function addHolidayHours(storeData, daysTime) {
    const holidays = [
        { name: 'New Year\'s Day', key: 'New Years Day' },
        { name: 'New Year\'s Eve', key: 'New Years Eve' },
        { name: 'Boxing Day', key: 'Boxing Day' },
        { name: 'Christmas Eve', key: 'Christmas Eve' },
        { name: 'Monday Jan 13th', key: 'Monday Jan 13th' },
        { name: 'Easter Sunday', key: 'Easter Sunday' },
        { name: 'Easter Friday', key: 'Easter Friday' },
        { name: 'Victoria Day', key: 'Victoria Day'}
    ];

    holidays.forEach(holiday => {
        const holidayTime = storeData[holiday.key];
        if (holidayTime) {
            const newTimeItem = document.createElement("li");
            newTimeItem.innerHTML = `<span>${holiday.name}</span><span class="days-time" style="padding-right:0px;"> ${holidayTime.open} <span class="space-manage"> - </span> ${holidayTime.close}</span>`;
            newTimeItem.id = holiday.key.replace(/\s/g, '-').toLowerCase();

            const existingItem = daysTime.querySelector(`#${newTimeItem.id}`);
            if (existingItem) {
                daysTime.removeChild(existingItem);
            }
            daysTime.prepend(newTimeItem);
        } else {
            console.warn(`Holiday not found: ${holiday.key}`);
        }
    });
}
